import { Component, Input, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'

import { environment } from '../../../environments/environment'
import { AuthService } from './auth.service'
import { IsAccountService, IsTokenService } from '@interserve/angular'

declare const window: {
  location: { origin: string }
  BeLoginCore: { login: () => void }
}
@Component({
    selector: 'app-isbeauth',
    template: '',
    imports: [CommonModule]
})
export class IsbeauthComponent implements OnInit {
  loginUrl = location.protocol + environment.login.isbeLogin
  baseUrl = window.location.origin
  core: any
  // appLogo = `${document.baseURI}assets/images/common/logo.png`
  isAppCd = environment.login.isbeAppCd
  copyright = environment.login.copyright
  accountId: string | null = null // ログインID、パスワードを初期表示する場合に設定
  constructor(
    private authService: AuthService,
    private _isAccountService: IsAccountService,
    private _isTokenService: IsTokenService
  ) {}

  ngOnInit(): void {
    this.accountId = this.authService.AutoLoginAccountId
    if (this.accountId) {
      this.authService.resetAutoLoginAccountId()
    }
    const that = this
    //ログイン処理
    const isbeLoginScriptPath = environment.login.isbeLoginScript
    const isbeLoginScriptElem = document.createElement('script')

    isbeLoginScriptElem.setAttribute('id', 'belogin-script')
    isbeLoginScriptElem.setAttribute('src', isbeLoginScriptPath)
    document.head.appendChild(isbeLoginScriptElem)
    isbeLoginScriptElem.onload = function () {
      that.loginUrl = environment.login.isbeLogin
      that.baseUrl = window.location.origin
      that.core = window.BeLoginCore
      that.core.initialize(that)
      isbeLoginScriptElem.onload = null
    }
  }
  onBeginLogin = (): void => {}

  // ログイン後処理
  onEndLogin = (account: string): void => {
    const acc = this.convertCamel(account)
    this.authService.setAccount(acc)
    this._isAccountService.setAccount(acc)
    this._isTokenService.setToken(acc.token)
  }

  convertCamel = (stringJson: string) => {
    //jsonKeyを小文字始まりに変換
    const json = JSON.parse(stringJson, function (key, value) {
      if (value && typeof value === 'object')
        for (var k in value) {
          if (/^[A-Z]/.test(k) && Object.hasOwnProperty.call(value, k)) {
            value[k.charAt(0).toLowerCase() + k.substring(1)] = value[k]
            delete value[k]
          }
        }
      return value
    })
    return json
  }
}
